import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/auth-store';
import type { ReactNode } from 'react';

/**
 * AuthGuard: wrap route yang butuh login.
 * Kalau token tidak valid (no token / expired) → redirect ke /login dengan
 * `from` state agar bisa balik ke halaman yang user mau setelah login sukses.
 */
export function AuthGuard({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}
